import { useEffect, useState } from "react";
import { AdminHeader } from "./AdminHeader";
import { MainContain } from "../Private/MainDashboard/MainContent/MainContain";
import { Footer } from "../Private/MainDashboard/MainContent/Footer/Footer";
import { AdminSidebar } from "../Private/MainDashboard/Sidebar/AdminSidebar";

function MainDashboard() {
  const [isopen, setIsOpen] = useState(true);
  
  const toggle = () => {
    setIsOpen(!isopen);
  };

  return (
    <>
      {/* <div className="wrapper"> */}
      <div className="container-scroller ms-2" style={{ backgroundColor: '#ececec' }}>
        <div className="row background_main_all px-1 ">
          <AdminHeader
            toggle={toggle} isopen={isopen}

          />

          <div className="container-fluid page-body-wrapper mx-0">
            {/* {
              show && */}
            <AdminSidebar isopen={isopen} setIsOpen={setIsOpen} active="dashboard" />
            {/* } */}
            <div className="main-panel" style={{ width: isopen ? "" : "calc(100%  - 1px )", marginLeft: isopen ? "" : "1px" }}>
              <div className="content-wrapper ps-3 ">

                <h5 className="fw-bold pb-2">Admin Dashboard</h5>
                <MainContain />

                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default MainDashboard;
